module.exports = __webpack_public_path__ + "img/four3Green.3492bc81.jpg";